// 交易相关接口
import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 获取账户类型数据 -- 充值信息
export function getAmountAccountType (): any {
  return request('/saas/gtpw/transaction/getAmountAccountType')
}

/**
 * @param {string} code 金额收取渠道
 * @param {string} currencyCode 币种
 * @param {number} money 金额
 * @description: 全球货仓账户金额充值入口
 */
export function accountRecharge (params: {
  code: string;
  currencyCode: string;
  money: number;
  payType?: string; // 0余额充值；1保证金充值
}): any {
  return request(`/saas/gtpw/transaction/accountRecharge?${formatParam(params)}`, {
    method: 'POST'
  })
}

/**
 * 专门用于提供生成二维码图片流
 * -生成-支付-二维码-
 */
export function createPayQRCode (params: {
  data: string;
  width: number;
}): any {
  return request(`/saas/gtpw/transaction/createPayQRCode?${formatParam(params)}`, {
    responseType: 'blob'
  })
}

/**
 * @param {string} bankCode 选中的充值渠道
 * @param {string} orderId 下单充值的订单号
 * @param {number} typeId 0 收入（相对于系统，其实就是商户充值） 1 支出(相对于系统来说是支出)
 * @description: 查询充值充值记录是否到账
 */
export function findRechargeLogs (params: {
  bankCode: string;
  orderId: string;
  typeId: number;
}): any {
  return request(`/saas/gtpw/transaction/findRechargeLogs?${formatParam(params)}`)
}

// 获取用户提现账户信息
export function getCurrentUserAccount (params): any {
  return request(`/saas/gtpw/transaction/getCurrentUserAccount?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 获取当前用户的账户余额信息
export function currentUserBalance (): any {
  return request('/saas/gtpw/transaction/currentUserBalance')
}

// 提现功能
export function currentUserWithdrawals (params): any {
  return request(`/saas/gtpw/transaction/currentUserWithdrawals?${formatParam(params)}`, {
    method: 'POST',
    data: params
  })
}

// 获取提现申请记录列表
export function findPayDrawmoneyListByCurrency (params): any {
  return request(`/saas/gtpw/transaction/fundChangeList?${formatParam(params)}`, {
    method: 'POST',
    data: params
  })
}

// 获取当前用户某个币种的账户金额情况
// 不限制账户的状态;内部加入了redis控制，防止同一个运营商的同一个币种访问太过频繁；balance.status != 0的情况下，证明当前账户不是有效的，需要根据情况判断；orderCount：未完成订单统计；minGuaranteeMoney：最低账户保留金额
export function findBalanceByCurrentUser (params: {
  currencyCode: string
}): any {
  return request(`/saas/gtpw/transaction/findBalanceByCurrentUser?${formatParam(params)}`, {
    method: 'GET',
    data: params
  })
}

// 获取当前用户某个币种的账户金额情况
// 由于接口不限制登录用户，所以参数判断相对严谨一点。typeId：0收入，1支出；treeId：产品类型(如果传入Pay，type必须要=1，如果传入Cancel，type=0)；sdate：起始时间[yyyy-MM-dd]；edate：结束时间[yyyy-MM-dd]；orderId：订单编号或充值、提现单号；orderStatus：订单状态或提现状态；syncDbLink：串货运营商系统ID；syncMchId：串货运营商ID
export function fundChangeListExport (params): any {
  return request(`/saas/gtpw/transaction/fundChangeListExport?${formatParam(params)}`, {
    method: 'GET',
    data: params,
    responseType: 'blob'
  })
}
